window.SystemInfoCollector ??= class SystemInfoCollector {
  constructor() {
    this.appVersion = window.utilsString.general.version || 'Unknown';
    this.userAgent = navigator.userAgent;
    this.uaData = navigator.userAgentData || null;
  }

  async getOS() {
    if (this.uaData && this.uaData.platform) {
      return this.uaData.platform;
    }

    // Fallback using userAgent string
    if (/Windows NT/.test(this.userAgent)) return 'Windows';
    if (/Mac OS X/.test(this.userAgent)) return 'Mac';
    if (/Android/.test(this.userAgent)) return 'Android';
    if (/iPhone|iPad|iPod/.test(this.userAgent)) return 'iOS';
    if (/Linux/.test(this.userAgent)) return 'Linux';

    return 'Unknown';
  }

  getDeviceType() {
    if (/Mobi|Android/i.test(this.userAgent)) {
      return /Tablet|iPad/i.test(this.userAgent) ? 'Tablet' : 'Mobile';
    }
    return 'Laptop';
  }

  getBrowserInfo() {
    let type = 'Unknown';
    let version = 'Unknown';

    if (/Chrome/.test(this.userAgent)) {
      type = 'Chrome';
      version = this.userAgent.match(/Chrome\/([0-9.]+)/)?.[1];
    } else if (/Safari/.test(this.userAgent) && !/Chrome/.test(this.userAgent)) {
      type = 'Safari';
      version = this.userAgent.match(/Version\/([0-9.]+)/)?.[1];
    } else if (/Firefox/.test(this.userAgent)) {
      type = 'Firefox';
      version = this.userAgent.match(/Firefox\/([0-9.]+)/)?.[1];
    }

    return { type, version };
  }

  getOSVersion() {
    const match = this.userAgent.match(/(Windows NT|Mac OS X|Android|CPU (iPhone)? OS) ([\d_]+)/);
    return match ? match[3].replace(/_/g, '.') : 'Unknown';
  }

  getScreenResolution() {
    const width = window.screen.width;
    const height = window.screen.height;
    return `${width}x${height}`;
  }

  async getInfo() {
    const operatingSystem = await this.getOS();
    const osVersion = this.getOSVersion();
    const deviceType = this.getDeviceType();
    const { type: browserType, version: browserVersion } = this.getBrowserInfo();

    return {
      deviceType,
      manufacturer: null,
      model: null,
      operatingSystem,
      osVersion,
      appVersion: this.appVersion,
      browserType,
      browserVersion,
      browserUserAgent: this.userAgent,
      screenResolution: this.getScreenResolution(),
    };
  }
};
